import React from 'react';
import PropTypes from 'prop-types';

function DashboardCrews(props) {
  const { height, width } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 120 92" xmlns="http://www.w3.org/2000/svg">
      <g id="Page-1" fill="none" fillRule="evenodd">
        <g id="LL_Batch6_Crews" transform="translate(1 1)">
          <polygon
            id="Path"
            fill="#52B7B0"
            opacity="0.4"
            points="118.36 44.23 110.58 36.45 71.68 75.36 56.66 60.35 48.88 68.13 71.69 90.93 79.47 83.15 79.45 83.14"
          />
          <circle id="Oval" stroke="#333" strokeWidth="2.16" cx="49.8" cy="18.23" r="17.51" />
          <circle id="Oval" stroke="#333" strokeWidth="2.16" cx="83.62" cy="34.93" r="9.59" />
          <path
            d="M82.4700121,73.63 C82.473111,70.238889 81.8772938,66.8738763 80.71,63.69"
            id="Path"
            stroke="#333"
            strokeWidth="2.16"
          />
          <path
            d="M73.21,52.25 C66.992161,46.3470985 58.7334368,43.0758555 50.16,43.12 C32.31,43.12 17.84,56.78 17.84,73.63"
            id="Path"
            stroke="#333"
            strokeWidth="2.16"
          />
          <path
            d="M99.61,63.69 C99.61,55.36 92.45,48.6 83.61,48.6 C79.8230475,48.580591 76.1456526,49.8699754 73.2,52.25 C76.5426499,55.4390304 79.1085543,59.3528899 80.7,63.69"
            id="Path"
            stroke="#333"
            strokeWidth="2.16"
          />
          <circle id="Oval" stroke="#333" strokeWidth="2.16" cx="17.29" cy="35.09" r="9.63" />
          <path
            d="M27,52.38 C24.024947,49.9196617 20.2805538,48.5818729 16.42,48.6 C9.3378732,48.4949772 3.04460009,53.0986166 1,59.88"
            id="Path"
            stroke="#333"
            strokeWidth="2.16"
          />
          <path
            d="M0.91,59.88 C0.562248717,61.120037 0.387265223,62.4021276 0.39,63.69"
            id="Path"
            stroke="#333"
            strokeWidth="2.16"
          />
        </g>
      </g>
    </svg>
  );
}

DashboardCrews.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

DashboardCrews.defaultProps = {
  width: 120,
  height: 92
};

export default DashboardCrews;
